import "../scss/app.scss";
import Vue from "vue";
import "bootstrap";

import initHamburger from "./hamburger";
import initKeyVisualSlider from "./keyVisualSlider";
import initFilter from "./filter";
import initModal from "./modal";
import initScrollTrigger from "./scrollTrigger";
import initContactForm from "./contactForm";

const app = new Vue({
  el: "#app",

  data: {
    isToggleMenu: false,
  },
  mounted() {
    initHamburger();
    initFilter();
    initModal();
    initScrollTrigger();
    initContactForm();
    initKeyVisualSlider();
  },
});
